// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NoMatchScreen from './NoMatchScreen';
import MatchResultScreen from './MatchResultScreen';

export default function ResultScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const { result } = location.state || {};

  // If no result data, redirect to home
  if (!result) {
    navigate('/', { replace: true });
    return null;
  }

  // Route to appropriate result screen based on match status
  if (!result.match) {
    return <NoMatchScreen />;
  }

  // Match found - show match result screen
  return <MatchResultScreen />;
}
